export default "__VITE_ASSET__wRRFQM2V__"